import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M15.69,14.58a5.52,5.52,0,1,0-4.42,2.21h0a5.52,5.52,0,0,0,3.3-1.1l2.54,2.55,1.12-1.12Zm-.48-3.3A3.88,3.88,0,0,1,14.1,14L14,14.1a3.9,3.9,0,0,1-2.74,1.11h0a3.94,3.94,0,1,1,3.93-3.93Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol